import { Component, OnInit,ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from '../../../shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from '../../../shared/services/auth.service';
import { KitchenStockPurchaseService } from '../../../shared/services/kitchen-stock-purchase.service';


@Component({
  selector: 'ngx-add-stock-list',
  templateUrl: './add-stock-list.component.html',
  styleUrls: ['./add-stock-list.component.scss']
})
export class AddStockListComponent implements OnInit {

  isDark: boolean = false;

  displayedColumns: string[] = ['item', 'qty','amount','created_at', 'created_by'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;

  stockList : any[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  constructor(
    private kitchenStockPurchaseService :KitchenStockPurchaseService, 
    private router : Router, 
    private route : ActivatedRoute, 
    private toastr: ToastrService,
    private themeService: NbThemeService,
    private dialogService: DialogService,
    private authService: AuthService,
   ) { }

ngOnInit() {

    this.getAll();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

}

getControlPermissions(){
  var data = [];
   data =  this.authService.controlPermissionArray.filter((el)=>{
    return el.moduleCode ==='KS'
  });
  if(data.length > 0){
    this.crud_access.read = data[0].read;
    this.crud_access.create = data[0].create;
    this.crud_access.approve = data[0].approve;
    this.crud_access.delete = data[0].delete;
  }
}

newButtonClick(){
  this.router.navigate(['../add-stock'],{relativeTo : this.route});
  }


  getAll(){
  this.kitchenStockPurchaseService.getAll()
   .subscribe(
      (data) => {
                this.stockList = data; 
                this.dataSource = new  MatTableDataSource (this.stockList);  
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;      
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  
    
   }
 


 applyFilter(){
  this.dataSource.filter =this.searchKey.trim().toLowerCase();

 }
 onSearchClear(){
   this.searchKey = "";
   this.applyFilter();
}



}//end class
